import { LinkAuthMethodOut } from '../../domains/ports/out/LinkAuthMethodOut';
import { CurrentUser } from '../../general/modules/user/currentUser';
import { LinkAuthMethodError } from '../../domains/valueObject/Errors/LinkAuthMethodError';
import { Localization } from '../../localization/localization';
import { AuthMethodAlreadyLinkedError } from '../../domains/valueObject/Errors/AuthMethodAlreadyLinkedError';
import { AuthMethod } from '../../account-window/parts/auth-method';
import { getLinkAuthMethodStrategy } from './link-auth-method';

export class LinkAuthMethod implements LinkAuthMethodOut {
    public async linkAuthMethod(
        authMethod: string,
        credentials: object,
        isBigReward: boolean
    ): Promise<true | Error> {
        try {
            const linkAuthMethodStrategy = getLinkAuthMethodStrategy(authMethod as AuthMethod);

            const response = await linkAuthMethodStrategy.link(window.app.deviceIdentifier, {
                authMethod,
                credentials,
                isBigReward,
                suid: CurrentUser.getInstance().getSuid()
                    .toString(),
                token: CurrentUser.getInstance().getAuthToken()
            });

            return response.success ? true : new LinkAuthMethodError(Localization._n('common_error'));
        } catch (exception) {
            console.error(exception);
            if (exception.code === 5004) {
                return new AuthMethodAlreadyLinkedError(exception.message);
            }
            window.Sentry.captureException(exception);
            return new LinkAuthMethodError(Localization._n('common_error'));
        }
    }
}
